import { useRef } from 'react'

type Props = {
  title: string;
  src: string;
  className: string;
}

export default function SimpleImage({ title, src, className }: Readonly<Props>) {
  const imageRef = useRef<HTMLImageElement | null>(null);
  const handleError = (e: any) => {
    e.target.src = `${process.env.PUBLIC_URL}/user-profile.svg`;
  }

  return (
    <img
      ref={imageRef}
      title={title ?? "Image"}
      alt={title ?? "Image"}
      src={src ?? `${process.env.PUBLIC_URL}/user-profile.svg`}
      onError={handleError}
      className={className}
    />
  )
}